import React, { useCallback } from 'react';
import StyledDropzone from 'src/Common/Components/Forms/StyledDropzone';
import useEkko from 'src/Common/Providers/EkkoProvider';

const convertResult = (result: string): string => {
  let base64Data = result.replace(/^.*,/, '');
  // Padding: The string should olways be a multiple of 4
  const danglingCharacterCount = base64Data.length % 4;
  if (danglingCharacterCount % 4 !== 0) {
    base64Data = base64Data + '='.repeat(4 - danglingCharacterCount);
  }

  return base64Data;
};

interface Props {
  /** provides the dropped "raw" file */
  fileCallback?: (file: File) => void;
  /** provides the template data */
  dataCallback?: (data: string) => void;
}

export const TemplateDropzone = ({ fileCallback, dataCallback }: Props): React.JSX.Element => {
  const {
    config: { acceptedTemplateFileTypes },
  } = useEkko();

  const onDrop = useCallback(
    (files: File[]) => {
      if (files.length === 0) {
        throw new Error(`Panic: OnDrop called while no files were provided`);
      }

      const file = files[0];
      fileCallback && fileCallback(file);

      if (dataCallback) {
        const reader = new FileReader();
        reader.onload = () => {
          dataCallback(convertResult(reader.result as string));
        };
        reader.readAsDataURL(file);
      }
    },
    [fileCallback, dataCallback],
  );

  return (
    <section style={{ width: '100%' }}>
      <StyledDropzone
        instructions={'Drop a layout file here, or click to select a layout file'}
        accept={acceptedTemplateFileTypes.join(',')}
        onDrop={onDrop}
        multiple={false}
      />
    </section>
  );
};
